import React, { useCallback, useState, useRef } from "react";
import Space from "./images/Space.jpg";
import Particles from "react-tsparticles";
import options from "./particles";
import Profile from "./components/Profile";
import { motion, useTransform, useScroll } from "framer-motion";
import { loadFull } from "tsparticles";
import "./index.css";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import ProjectsActual from "./components/ProjectsActual";

function App() {
  const [areParticlesLoaded, setParticlesLoaded] = useState(false);

  const particlesInit = useCallback(
    async (engine) => await loadFull(engine),
    []
  );

  const particlesLoaded = useCallback(async (container) => {
    await console.log(container);
    setParticlesLoaded(true);
  }, []);

  const particleVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  const containerRef = useRef(null);

  return (
    <div
      ref={containerRef}
      style={{
        "background-image": `linear-gradient(rgba(0, 0, 0, 0.677), rgba(0, 0, 0, 0.7)),url(${Space})`,
      }}
      className="w-screen h-full"
      id="app-scrollable-container"
    >
      <motion.div
        initial="hidden"
        animate="visible"
        variants={particleVariants}
        transition={{ delay: 0.5 }}
      >
        <Particles
          id="tsparticles"
          options={options}
          init={particlesInit}
          loaded={particlesLoaded}
        />
      </motion.div>

      <Profile containerRef={containerRef} />
      <br />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2 }}
        className="App w-screen lg:pt-0 pt-20"
      >
        <div
          className={`bg-[#ffffff08] backdrop-blur-md rounded-lg lg:w-3/5 w-full mx-auto`}
        >
          <Projects />
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2 }}
        className="App w-screen lg:pt-0 pt-20"
      >
        <div
          className={`bg-[#ffffff08] backdrop-blur-md rounded-lg lg:w-3/5 w-full mx-auto`}
        >
          <Experience />
        </div>
      </motion.div>

      {/* <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2 }}
        className="App w-screen lg:pt-0 pt-20"
      >
        <div
          className={`bg-[#ffffff08] backdrop-blur-md rounded-lg lg:w-3/5 w-full mx-auto`}
        >
          <ProjectsActual />
        </div>
      </motion.div> */}
    </div>
  );
}

export default App;
